module.exports = __webpack_public_path__ + "4df25a6c672c72e26d3d7388c142c9aa.svg";